var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.146 43.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "New Icons"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.573 0a21.573 21.573 0 1 0 21.573 21.573A21.573 21.573 0 0 0 21.573 0z",
    fill: "#011b33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.195 20.586l-5.773-4.235-5.299-3.885-.202-.148a.939.939 0 0 0-.605-.186l-1.861.133a1.317 1.317 0 0 0-1.217 1.311l-.001 7.992-.001 8.013a1.304 1.304 0 0 0 1.161 1.296l1.947.142a.94.94 0 0 0 .56-.189l.21-.153 5.306-3.889 5.775-4.231a1.26 1.26 0 0 0 0-1.971z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.195 20.585l-5.773-4.234-5.299-3.885-.202-.148a1.048 1.048 0 0 0-1.618.987l-.001 8.263-.001 8.284a1.038 1.038 0 0 0 1.602.978l.21-.153 5.307-3.889 5.775-4.231a1.26 1.26 0 0 0 0-1.972z",
    fill: "#00e1ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.91df2343eb27ee7da3d970fcedd7128c.svg";
export { ForwardRef as ReactComponent };